import { render, staticRenderFns } from "./Playtime.vue?vue&type=template&id=f08ad982&scoped=true"
import script from "./Playtime.vue?vue&type=script&lang=js"
export * from "./Playtime.vue?vue&type=script&lang=js"
import style0 from "./Playtime.vue?vue&type=style&index=0&id=f08ad982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08ad982",
  null
  
)

export default component.exports